module.exports = __webpack_public_path__ + "img/dometic_tropicool_tcx_07.6349a9ce.png";